function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgUcf(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 96 96",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    d: "M41 24H25a4 4 0 000 8h16a4 4 0 000-8zM41 40H25a4 4 0 000 8h16a4 4 0 000-8zM41 56H25a4 4 0 000 8h16a4 4 0 000-8z"
  }), React.createElement("path", {
    d: "M77.496 48H72v-5.496C72 36.712 67.288 32 61.496 32H57V19.504C57 13.712 52.288 9 46.496 9H19.504C13.712 9 9 13.712 9 19.504v57.992C9 83.288 13.712 88 19.504 88h26.992c1.669 0 3.243-.402 4.646-1.097.277.06.563.097.858.097H77.496C83.288 87 88 82.288 88 76.496V58.504C88 52.712 83.288 48 77.496 48zM19.504 80A2.506 2.506 0 0117 77.496V19.504A2.506 2.506 0 0119.504 17h26.992A2.506 2.506 0 0149 19.504v57.992A2.506 2.506 0 0146.496 80H19.504zM60 79h-3.12c.071-.493.12-.992.12-1.504V40h4.496A2.506 2.506 0 0164 42.504v33.992A2.506 2.506 0 0161.496 79H60zm20-2.504A2.506 2.506 0 0177.496 79h-5.81c.198-.804.314-1.64.314-2.504V56h5.496A2.506 2.506 0 0180 58.504v17.992z"
  }));
}

SvgUcf.clsName = 'icon-www__ucf';
SvgUcf.remarkName = 'unknown';
export default SvgUcf;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/Ucf.js
// module id = 2455
// module chunks = 17 18